export const renderTime = (timestamp, preferences, noTimeZone) => {
  let timeFormat = preferences.userTimeFormat === 12 ? 'MM/DD/YYYY h:mm A zz' : 'MM/DD/YYYY HH:mm zz';
  if (noTimeZone) {
    timeFormat = preferences.userTimeFormat === 12 ? 'MM/DD/YYYY h:mm A' : 'MM/DD/YYYY HH:mm';
  }

  return moment.tz(timestamp, preferences.tz).format(timeFormat);
};
// Generates generic products based on specific product objects.
// Given a skyguard object it converts it to a generic product.
const userUtils = function() {
  const factory = {};

  factory.inContextSwitch = userState => userState.context.clientId !== userState.context.userClientId;
  factory.renderTime = renderTime;

  return factory;
};

export default userUtils();
